import React, { useState } from "react";
import { motion } from "framer-motion";
import {
  FaGithub,
  FaExternalLinkAlt,
  FaReact,
  FaNode,
  FaPython,
  FaDatabase,
  FaFire,
  FaDocker,
  FaAws,
  FaCode,
  FaSearch,
  FaMobile,
  FaDesktop,
  FaServer,
  FaHtml5,
  FaFileWord,
} from "react-icons/fa";
import {
  SiTypescript,
  SiJavascript,
  SiMongodb,
  SiPostgresql,
  SiFirebase,
  SiTailwindcss,
  SiRedux,
  SiGraphql,
  SiKubernetes,
  SiPandas,
  SiStreamlit,
  SiNumpy,
  SiBoosty,
  SiPlotly,
  SiDart,
  SiGooglefonts,
  SiGooglegemini,
  SiReact,
  SiExpress,
  SiNodedotjs,
  SiClaude,
  SiLibrarything,
  SiSolidity,
  SiWeb3Dotjs,
  SiEthereum,
  SiHiveBlockchain,
} from "react-icons/si";

import { useNavigate } from "react-router-dom"; //for live button developing code handling

import { GiFoxHead, GiPickle } from "react-icons/gi";
import { FaCodePullRequest, FaFlutter } from "react-icons/fa6";
import { MdApi, MdHttp, MdMail } from "react-icons/md";
import { PiMouseScrollFill } from "react-icons/pi";

import "./Projects.css";

const Projects = () => {
  const [filter, setFilter] = useState("all");

  const projects = [
    {
      id: 1,
      title: "Digi Agency : Scaling Brands",
      description:
        "A dynamic website solution for service-based agencies, featuring an AI-powered builder, admin panel for content management, and a confidential super admin panel for secure operations.",
      image: "projects/sane.png",
      category: "web",
      featured: true,
      techStack: [
        { name: "React", icon: <FaReact /> },
        { name: "Node.js", icon: <FaNode /> },
        { name: "MongoDB", icon: <SiMongodb /> },
        { name: "Redux", icon: <SiRedux /> },
        { name: "Claude", icon: <SiClaude /> },
      ],
      links: {
        github:
          "https://github.com/machinelearningprodigy/Sane-Infotech---Fronted",
        live: "https://sane-infotech-internship.vercel.app/",
      },
      highlights: [
        "Designed for service-based agencies with an Admin Panel",
        "Enables rapid website creation for multiple clients enabling 100% resuability",
        "Admin Panel for content management & Super Admin for secure controls.",
        "Automates and streamlines website development.",
      ],
    },
    {
      id: 2,
      title: "Finance.Pro - Analytics Dashboard",
      description:
        "Advanced analytics platform using machine learning for predictive insights and data visualization.",
      image: "projects/finance.png",
      category: "web",
      featured: true,
      techStack: [
        { name: "Typescript", icon: <SiTypescript /> },
        { name: "Redux", icon: <SiRedux /> },
        { name: "MongoDB", icon: <SiMongodb /> },
        { name: "Express", icon: <SiExpress /> },
        { name: "Node", icon: <SiNodedotjs /> },
      ],
      links: {
        github: "https://github.com/machinelearningprodigy/Finance.Pro",
        live: "https://finance-pro-xi.vercel.app/",
      },
      highlights: [
        "React.js (frontend), Node.js + Express.js (backend), MongoDB Atlas (database), JWT authentication.",
        "Dashboard (overview), Profile (user data), Reports (income, expenses, savings).",
        "Custom plans, tracking, reminders, analytics, future projections, sharing.",
        "Scalable, secure, and reliable 24/7 cloud hosting.",
      ],
    },

    {
      id: 3,
      title: "Food Ordering System",
      description:
        "The Food Ordering System is a full-stack web app built with Next.js (frontend) and Node.js/Express (backend). It allows users to browse menus, place orders, and manage their profiles with authentication. The system features a dynamic menu and a secure API for seamless user-restaurant interaction.",
      image: "projects/food.png",
      category: "backend",
      featured: true,
      techStack: [
        { name: "Express", icon: <SiExpress /> },
        { name: "Redux", icon: <SiRedux /> },
        { name: "Node", icon: <SiNodedotjs /> },
        { name: "MongoDB", icon: <SiMongodb /> },
        { name: "React", icon: <SiReact /> },
        { name: "AWS", icon: <FaAws /> },
      ],
      links: {
        github:
          "https://github.com/machinelearningprodigy/Food-Ordering-System",
        live: "/developing", // Changed this
        isDeveloping: true, // Add this flag
      },
      highlights: [
        "Built with Next.js (frontend) & Node.js/Express (backend)",
        "Users can browse menus, place orders & manage profiles",
        "Includes authentication & a dynamic menu system",
        "Secure API for smooth user-restaurant interaction",
      ],
    },
    {
      id: 4,
      title: "Patabodh - Envisioning Leaf",
      description:
        "A machine learning-powered app for Assam tea growers to detect tea leaves and identify plant diseases using real-time or uploaded images, even working offline. It enhances productivity with advanced features and seamless user experience.",
      image: "projects/leaf.png",
      category: "mobile",
      featured: false,
      techStack: [
        { name: "Flutter", icon: <FaFlutter /> },
        { name: "Dart", icon: <SiDart /> },
        { name: "HTTP", icon: <MdHttp /> },
        { name: "Mailer", icon: <MdMail /> },
        { name: "Google Fonts", icon: <SiGooglefonts /> },
      ],
      links: {
        github: "https://github.com/machinelearningprodigy/IITG-Project",
        live: "/developing", // Changed this
        isDeveloping: true, // Add this flag
      },
      highlights: [
        "Machine learning app detects tea leaves and plant diseases in real-time or via image uploads.",
        "Offline caching stores images when there's no network, with notifications once results are available.",
        "Targeted at tea growers in Assam to enhance productivity and decision-making.",
        "Additional advanced features to support the practical needs of tea gardeners.",
      ],
    },

    {
      id: 5,
      title: "Movie Recommendation System",
      description:
        "A Streamlit-based Movie Recommender System that suggests the top 5 similar movies based on user selection using precomputed similarity scores. It features an interactive UI, TMDB-powered movie posters, and a seamless recommendation experience.",
      image: "projects/movie.png",
      category: "mobile",
      featured: false,
      techStack: [
        { name: "Python", icon: <FaPython /> },
        { name: "Pickle", icon: <GiPickle /> },
        { name: "Request", icon: <FaCodePullRequest /> },
        { name: "API", icon: <MdApi /> },
        { name: "Streamlit", icon: <SiStreamlit /> },
      ],
      links: {
        github:
          "https://github.com/machinelearningprodigy/movie-recommender-system",
        live: "https://movie-recommendation-system24.streamlit.app/",
      },
      highlights: [
        "Personalized Recommendations: Get 5 similar movie suggestions based on your selection.",
        "Movie Posters: Visual preview of each recommended movie with its poster.",
        "Pre-trained Model: Uses similarity.pkl to calculate similarity scores.",
        "TMDB API: Provides movie posters and up-to-date movie data.",
      ],
    },
    {
      id: 6,
      title: "Heart Disease Predictor System",
      description:
        "A Streamlit-based heart disease prediction app using an XGBoost model, allowing real-time input analysis of 13 clinical features. It provides dynamic predictions with visual insights through interactive Plotly charts.",
      image: "projects/heart.png",
      category: "mobile",
      featured: false,
      techStack: [
        { name: "Pandas", icon: <SiPandas /> },
        { name: "Streamlit", icon: <SiStreamlit /> },
        { name: "Numpy", icon: <SiNumpy /> },
        { name: "Xgboost", icon: <SiBoosty /> },
        { name: "Plotly", icon: <SiPlotly /> },
      ],
      links: {
        github:
          "https://github.com/machinelearningprodigy/Heart-Disease-Prediction",
        live: "/developing", // Changed this
        isDeveloping: true, // Add this flag
      },
      highlights: [
        "XGBoost model (Heart.pkl) predicts heart disease risk based on user input.",
        "Dynamic bar and pie charts show the influence of factors like age and gender.",
        "User-friendly interface with sliders and dropdowns for easy input.",
        "Real-time, color-coded heart disease predictions with instant feedback.",
      ],
    },
    {
      id: 7,
      title: "Career.AI - Making Career Choice Easy",
      description:
        "Advanced analytics platform using machine learning for predictive insights and data visualization.",
      image: "projects/career.png",
      category: "data",
      featured: true,
      techStack: [
        { name: "Gemini", icon: <SiGooglegemini /> },
        { name: "Redux", icon: <SiRedux /> },
        { name: "HTML", icon: <FaHtml5 /> },
        { name: "Scroll", icon: <PiMouseScrollFill /> },
        { name: "React", icon: <SiReact /> },
      ],
      links: {
        github: "https://github.com/username/microservices",
        live: "https://microservices-demo.com",
      },
      highlights: [
        "AI-powered chatbot for career guidance, job insights, and personalized recommendations.",
        "Over 5 learning resources, including career pathways, skills assessment, and job market insights.",
        "More than 10 dynamic pages, including blog, success stories, profile dashboard, and landing page.",
        "Fully responsive UI with smooth animations, modern design, and mobile compatibility.",
      ],
    },
    {
      id: 8,
      title: "Bike Model Minder",
      description:
        "This Model Minder Bike Classifier is a Streamlit-based image classification app using EfficientNetB0 to predict bike types from uploaded images. It provides top-5 predictions with confidence scores and a visualization of classification results.",
      image: "projects/bike.png",
      category: "data",
      featured: true,
      techStack: [
        { name: "Word2Vec", icon: <FaFileWord /> },
        { name: "Pandas", icon: <SiPandas /> },
        { name: "Streamlit", icon: <SiStreamlit /> },
        { name: "Plotly", icon: <SiPlotly /> },
        { name: "Numpy", icon: <SiNumpy /> },
        { name: "Xgboost", icon: <SiBoosty /> },
      ],
      links: {
        github:
          "https://github.com/machinelearningprodigy/Bike-Model/blob/main/bike.py",
        live: "https://bike-model-kxhqhrqe4syrpsgogvvv5j.streamlit.app/",
      },
      highlights: [
        "Streamlit app for bike classification using EfficientNetB0",
        "Users can upload images to get top-5 predictions",
        "Displays confidence scores with a bar chart visualization",
        "Allows users to download the uploaded image",
      ],
    },
    {
      id: 9,
      title: "Spam Classification Model",
      description:
        "This SMS Spam Classifier is a Streamlit-based application that detects whether a given SMS message is spam or not using NLTK for text preprocessing and a trained ML model. It preprocesses input text, vectorizes it, and predicts the result instantly.",
      image: "projects/spam.png",
      category: "data",
      featured: true,
      techStack: [
        { name: "NLTK", icon: <SiLibrarything /> },
        { name: "Numpy", icon: <SiNumpy /> },
        { name: "Xgboost", icon: <SiBoosty /> },
        { name: "Plotly", icon: <SiPlotly /> },
        { name: "Pandas", icon: <SiPandas /> },
        { name: "Streamlit", icon: <SiStreamlit /> },
      ],
      links: {
        github:
          "https://github.com/machinelearningprodigy/sms-spam-classiifer/blob/main/app.py",
        live: "https://spam-classiifer-24.streamlit.app/",
      },
      highlights: [
        "Streamlit app for SMS spam detection",
        "Uses NLTK for text preprocessing & stemming",
        "Employs a trained ML model for classification",
        "Displays spam or not spam result instantly",
      ],
    },
    {
      id: 10,
      title: "Sentiment Analysis Model",
      description:
        "This Twitter Sentiment Analysis app, built with Streamlit, predicts whether a given comment is Positive or Negative using Logistic Regression. It preprocesses text, vectorizes it, and displays sentiment results with a visually appealing UI.",
      image: "projects/sentiment.png",
      category: "data",
      featured: true,
      techStack: [
        { name: "Pandas", icon: <SiPandas /> },
        { name: "Streamlit", icon: <SiStreamlit /> },
        { name: "Numpy", icon: <SiNumpy /> },
        { name: "Claude", icon: <SiClaude /> },
        { name: "Xgboost", icon: <SiBoosty /> },
        { name: "Plotly", icon: <SiPlotly /> },
      ],
      links: {
        github:
          "https://github.com/machinelearningprodigy/sentiment-analysis/blob/main/app.py",
        live: "https://sentiment-analysis-23.streamlit.app/",
      },
      highlights: [
        "Streamlit app for Twitter sentiment analysis",
        "Uses NLP techniques for text preprocessing",
        "Employs Logistic Regression for classification",
        "Displays results with color-coded sentiment UI",
      ],
    },
    {
      id: 11,
      title: "To Do List",
      description:
        "The Todo List project application that allows users to add, delete, and update tasks while filtering tasks based on their completion status. It integrates with an API for task management and uses React, Lucide Icons, and SweetAlert2 for a responsive, user-friendly interface.",
      image: "projects/todo.png",
      category: "mobile",
      featured: true,
      techStack: [
        { name: "Typescript", icon: <SiTypescript /> },
        { name: "Redux", icon: <SiRedux /> },
        { name: "MongoDB", icon: <SiMongodb /> },
        { name: "Express", icon: <SiExpress /> },
        { name: "Node", icon: <SiNodedotjs /> },
      ],
      links: {
        github:
          "https://github.com/machinelearningprodigy/MadifyTech",
        live: "https://madify-tech.vercel.app/",
      },
      highlights: [
        "Task management with add, delete, and update functionality.",
        "Real-time task filtering based on completion status.",
        "User-friendly interface with Lucide icons and SweetAlert2 notifications.",
        "API integration for task storage and retrieval."
      ],
    },
    {
      id: 12,
      title: "Tution Tokenizer Application",
      description:
        "This project, Tuition Tokenizer, leverages blockchain technology to tokenize tuition payments, enabling secure and transparent transactions. It integrates with MetaMask for seamless wallet connectivity and transaction handling.",
      image: "projects/tution.png",
      category: "web",
      featured: true,
      techStack: [
        { name: "Blockchain", icon: <SiHiveBlockchain /> },
        { name: "Metamask", icon: <GiFoxHead /> },
        { name: "Solidity", icon: <SiSolidity /> },
        { name: "Web3", icon: <SiWeb3Dotjs/> },
        { name: "Ethereum", icon: <SiEthereum /> },
        { name: "Node", icon: <SiNodedotjs /> },
      ],
      links: {
        github:
          "https://github.com/machinelearningprodigy/Tution-Tokenizer",
          live: "/developing", // Changed this
          isDeveloping: true // Add this flag
      },
      highlights: [
        "Enables secure and transparent handling of tuition fees using blockchain technology."  ,
        "Provides seamless wallet connectivity for managing and executing transactions through MetaMask." ,
        "Utilizes Solidity-based smart contracts to automate and enforce payment processes. ",
        "Features an intuitive user interface for easy interaction with the blockchain system. "
      ],
    }
  ];

  const categories = [
    { id: "all", label: "All Projects", icon: <FaCode /> },
    { id: "web", label: "Web Apps", icon: <FaDesktop /> },
    { id: "mobile", label: "Mobile Apps", icon: <FaMobile /> },
    { id: "backend", label: "Backend", icon: <FaServer /> },
    { id: "data", label: "Data & AI", icon: <FaSearch /> },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
    },
  };

  const filteredProjects =
    filter === "all"
      ? projects
      : projects.filter((project) => project.category === filter);

  return (
    <div className="projects-container">
      {/* Header Section */}
      <motion.div
        className="projects-header"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h1>My Projects</h1>
        <p>Explore my latest work and side projects</p>
      </motion.div>

      {/* Filter Section */}
      <motion.div
        className="filter-container"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.2 }}
      >
        {categories.map((category) => (
          <button
            key={category.id}
            className={`filter-button ${
              filter === category.id ? "active" : ""
            }`}
            onClick={() => setFilter(category.id)}
          >
            {category.icon}
            <span>{category.label}</span>
          </button>
        ))}
      </motion.div>

      {/* Projects Grid */}
      <motion.div
        className="projects-grid"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        {filteredProjects.map((project) => (
          <motion.div
            key={project.id}
            className="project-card"
            variants={itemVariants}
          >
            <div className="project-image">
              <img src={project.image} alt={project.title} />
              {project.featured && (
                <span className="featured-badge">Featured</span>
              )}
            </div>

            <div className="project-content">
              <h3>{project.title}</h3>
              <p className="project-description">{project.description}</p>

              <div className="tech-stack">
                <h4>Tech Stack</h4>
                <div className="tech-icons">
                  {project.techStack.map((tech, index) => (
                    <div key={index} className="tech-icon" title={tech.name}>
                      {tech.icon}
                      <span className="tech-name">{tech.name}</span>
                    </div>
                  ))}
                </div>
              </div>

              <div className="project-highlights">
                <h4>Highlights</h4>
                <ul>
                  {project.highlights.map((highlight, index) => (
                    <li key={index}>{highlight}</li>
                  ))}
                </ul>
              </div>

              <div className="project-links">
                <a
                  href={project.links.github}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-github"
                >
                  <FaGithub /> Source Code
                </a>
                <a
                  href={project.links.live}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-live"
                >
                  <FaExternalLinkAlt /> Live Demo
                </a>
              </div>
            </div>
          </motion.div>
        ))}
      </motion.div>
    </div>
  );
};

export default Projects;
